<div class="card-body warning">
  <div class="result-img">
    <span class="icon-ic_big_a"></span>
  </div>
  <div class="result-title">
    <p [innerHTML]="headerText | translate"></p>
  </div>
  <button class="btn btn-link" (click)="goToSummary()">{{ "REFERENCE" | translate }} #{{ referenceNumber }}</button>
  <div class="result-text">
    <p [innerHTML]="text | translate"></p>
  </div>
</div>
